
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
const Chart = require("chart.js");

@Component
export default class UploadedArticlesReport extends Vue {
	private chart: any = null;
	private uploadReport: any = [];
	private loading: boolean = false;
	private year: number = new Date().getFullYear();

	private mounted() {
		this.loadReport();
	}

	private get years() {
		var lastYears = [];
		for (let index = new Date().getFullYear(); index >= 2023; index--) {
			lastYears.push(index);
		}
		return lastYears;
	}

	@Watch("year")
	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetUploadedArticlesPerRegion?year=${this.year}`
			);
			this.uploadReport = response.data;
			this.updateDiagram();
		} catch (err) {
			console.error("Loading report failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private getData() {
		const colors = {
			tealLight: "#4DB6AC",
			tealDark: "#00796B",
			blueLight: "#64B5F6",
			blueDark: "#1976D2",
			purpleLight: "#BA68C8",
			purpleDark: "#7B1FA2",
		};

		var data = {
			labels: this.uploadReport.map(
				(c: any) =>
					`${new Date(c.timeFrame).getMonth() + 1}-${new Date(c.timeFrame).getFullYear()}`
			),
			datasets: [
				{
					label: "CH Bestellbar",
					data: this.uploadReport.map(
						(r: any) =>
							r.regions
								.filter((re: any) => re.regionName == "CH/LI")[0]
								.articles.filter((ar: any) => ar.state == 0)[0].count
					),
					backgroundColor: colors.tealLight,
					stack: "Stack 0",
				},
				{
					label: "CH Error",
					data: this.uploadReport.map(
						(r: any) =>
							r.regions
								.filter((re: any) => re.regionName == "CH/LI")[0]
								.articles.filter((ar: any) => ar.state == 1)[0].count
					),
					backgroundColor: colors.tealDark,
					stack: "Stack 0",
				},
				{
					label: "DE Bestellbar",
					data: this.uploadReport.map(
						(r: any) =>
							r.regions
								.filter((re: any) => re.regionName == "DE")[0]
								.articles.filter((ar: any) => ar.state == 0)[0].count
					),
					backgroundColor: colors.blueLight,
					stack: "Stack 1",
				},
				{
					label: "DE Error",
					data: this.uploadReport.map(
						(r: any) =>
							r.regions
								.filter((re: any) => re.regionName == "DE")[0]
								.articles.filter((ar: any) => ar.state == 1)[0].count
					),
					backgroundColor: colors.blueDark,
					stack: "Stack 1",
				},
				{
					label: "AT Bestellbar",
					data: this.uploadReport.map(
						(r: any) =>
							r.regions
								.filter((re: any) => re.regionName == "AT")[0]
								.articles.filter((ar: any) => ar.state == 0)[0].count
					),
					backgroundColor: colors.purpleLight,
					stack: "Stack 2",
				},
				{
					label: "AT Error",
					data: this.uploadReport.map(
						(r: any) =>
							r.regions
								.filter((re: any) => re.regionName == "AT")[0]
								.articles.filter((ar: any) => ar.state == 1)[0].count
					),
					backgroundColor: colors.purpleDark,
					stack: "Stack 2",
				},
			],
		};
		return data;
	}

	private updateDiagram() {
		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}
		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");

		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "bar",
			// The data for our dataset
			data: this.getData(),
			options: {
				plugins: {
					title: {
						display: false,
						text: "Chart.js Bar Chart - Stacked",
					},
				},
				responsive: true,
				interaction: {
					intersect: false,
				},
				scales: {
					x: {
						stacked: true,
					},
					y: {
						stacked: true,
					},
				},
			},
		});
		this.chart.update();
	}
}
